import { useState } from "react";

// Occupation picker for the patient forms: common occupations, with "Other"
// for anything else. Stored as plain text, so older free-text values still show.
export const OCCUPATIONS = [
  "Student", "Homemaker", "Salaried - private sector", "Government employee", "Self-employed / business owner",
  "IT / software professional", "Doctor / healthcare worker", "Teacher / academic", "Lawyer / legal professional",
  "Engineer", "Banking / finance", "Farmer / agriculture", "Skilled trade (electrician, plumber, etc.)",
  "Daily wage worker / labourer", "Driver / transport", "Retail / sales", "Hospitality / food service",
  "Armed forces / police", "Artist / media / creative", "Unemployed / looking for work", "Retired",
];

const fieldClass = "w-full px-4 py-3 border border-secondary-200 rounded-xl bg-secondary-50 text-secondary-900 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all shadow-sm";

export default function OccupationSelect({ value, onChange }) {
  const [chooseOther, setOther] = useState(false);
  // "Other" when picked, or when the saved value isn't in the list (it may arrive after the form loads)
  const other = chooseOther || Boolean(value && !OCCUPATIONS.includes(value));
  return (
    <div className="space-y-2">
      <select aria-label="Occupation" value={other ? "__other" : value || ""} className={fieldClass}
        onChange={(e) => {
          if (e.target.value === "__other") { setOther(true); onChange(""); }
          else { setOther(false); onChange(e.target.value); }
        }}>
        <option value="">Select occupation</option>
        {OCCUPATIONS.map((o) => <option key={o} value={o}>{o}</option>)}
        <option value="__other">Other</option>
      </select>
      {other && <input aria-label="Other occupation" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Type the occupation" className={fieldClass} />}
    </div>
  );
}
